import React from 'react';

import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import theme from '@setup/theme/theme';

import type { LinkProps } from '@mui/material';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
  variantLink?: 'blue' | 'dark';
}

const variant: { [key: string]: object } = {
  dark: {
    '&.MuiLink-root': {
      fontSize: theme.typography.s3.fontSize,
      fontWeight: theme.typography.s3.fontWeight,
      lineHeight: theme.typography.s3.lineHeight,
      color: `${theme.palette.case.neutral.n600} !important`,
      '&:hover': {
        color: `${theme.palette.case.neutral.n700} !important`,
      },
      '&:active': {
        color: `${theme.palette.case.neutral.n800} !important`,
      },
    },
  },
};

export const MuiLink = (props: LinkRouterProps) => {
  const { target: linkTarget, rel, variantLink, sx, ...restProps } = props;
  const linkStyle = variantLink ? variant[variantLink] : {};

  const target = variantLink ? '_self' : linkTarget || '_blank';

  return (
    <Link
      {...restProps}
      sx={{ ...linkStyle, ...sx }}
      rel={rel || 'noreferrer'}
      target={target}
      component={RouterLink}
    />
  );
};
